<template>
  <div id="hbox" :class="{ 'is-fixed': isFixed, 'media-detail-page': isMediaDetailPage, 'media-key-page': isMediaKeyPage }">
    <div class="header-container">
      <router-link to="/" class="logo">
        <img :src="(isFixed || isMenuOpen) ? '/imgs/media/images/logo2_03.png' : '/imgs/start/images/logo_04.png'" alt="Logo" />
      </router-link>
      <div class="hamburger" @click="toggleMenu" :class="{ active: isMenuOpen }">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <nav class="nav-menu" :class="{ 'mobile-open': isMenuOpen }">
        <div class="nav-item-wrapper" :class="{ 'mobile-expanded': expandedMenus.about }" @click="handleNavClick('about', '/about', $event)">
          <div class="nav-item">
            <span>About Haili</span>
            <span class="mobile-arrow">▼</span>
          </div>
          <div class="dropdown-menu">
            <router-link to="/about#profile" class="dropdown-item" @click.native="closeMenu">Haili Profile</router-link>
            <router-link to="/about#culture" class="dropdown-item" @click.native="closeMenu">Our Culture</router-link>
            <router-link to="/about#milestones" class="dropdown-item" @click.native="closeMenu">Our Milestones</router-link>
            <router-link to="/about#certificates" class="dropdown-item" @click.native="closeMenu">Certificates</router-link>
          </div>
        </div>
        <div class="nav-item-wrapper" :class="{ 'mobile-expanded': expandedMenus.business }" @click="handleNavClick('business', '/products', $event)">
          <div class="nav-item">
            <span>Business Sectors</span>
            <span class="mobile-arrow">▼</span>
          </div>
          <div class="dropdown-menu">
            <router-link to="/products" class="dropdown-item" @click.native="closeMenu">Renewable Equipment Manufacturing</router-link>
            <router-link to="/business#wind-farm" class="dropdown-item" @click.native="closeMenu">Wind Farm Investment & Development</router-link>
            <router-link to="/business#t-i-services" class="dropdown-item" @click.native="closeMenu">T & I Services</router-link>
          </div>
        </div>
        <div class="nav-item-wrapper" :class="{ 'mobile-expanded': expandedMenus.manufacturing }" @click="handleNavClick('manufacturing', '/fabrication', $event)">
          <div class="nav-item">
            <span>Manufacturing</span>
            <span class="mobile-arrow">▼</span>
          </div>
          <div class="dropdown-menu">
            <router-link to="/fabrication" class="dropdown-item" @click.native="closeMenu">Fabrication Yards & Factories</router-link>
            <router-link to="/project-highlights" class="dropdown-item" @click.native="closeMenu">Project Highlights</router-link>
          </div>
        </div>
        <div class="nav-item-wrapper" :class="{ 'mobile-expanded': expandedMenus.media }" @click="handleNavClick('media', '/media', $event)">
          <div class="nav-item">
            <span>Media Centre</span>
            <span class="mobile-arrow">▼</span>
          </div>
          <div class="dropdown-menu">
            <router-link to="/media" class="dropdown-item" @click.native="closeMenu">Corporate News</router-link>
            <a href="https://www.cninfo.com.cn/new/disclosure/stock?stockCode=301155&orgId=9900047535#latestAnnouncement" target="_blank" class="dropdown-item" @click="closeMenu">Investor Relations</a>
          </div>
        </div>
        <div class="nav-item-wrapper" :class="{ 'mobile-expanded': expandedMenus.sustainability }" @click="handleNavClick('sustainability', '/ESG', $event)">
          <div class="nav-item">
            <span>Our Sustainability</span>
            <span class="mobile-arrow">▼</span>
          </div>
          <div class="dropdown-menu">
            <router-link to="/ESG" class="dropdown-item" @click.native="closeMenu">ESG</router-link>
          </div>
        </div>
        <div class="nav-item-wrapper" :class="{ 'mobile-expanded': expandedMenus.contact }" @click="handleNavClick('contact', '/hr', $event)">
          <div class="nav-item">
            <span>Contact Us</span>
            <span class="mobile-arrow">▼</span>
          </div>
          <div class="dropdown-menu">
            <router-link to="/hr" class="dropdown-item" @click.native="closeMenu">Careers</router-link>
            <router-link to="/contact" class="dropdown-item" @click.native="closeMenu">Contact Us</router-link>
          </div>
        </div>
        <div class="mobile-language" @click="goToChineseWebsite">
          <img src="/imgs/start/images/fuhao-zhongwen.png" class="language-icon" alt="中文" />
          <span>中文</span>
        </div>
        <div class="search-icon">
          <img src="/imgs/start/images/fuhao-zhongwen.png" class="language-icon" alt="中文" @click="goToChineseWebsite" style="cursor: pointer;" />
          <div class="phone-wrapper">
            <img src="/imgs/start/images/sousuo_03.png" alt="搜索" />
            <span class="phone-number">+86-10-68218026</span>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      isMenuOpen: false,
      isFixed: false,
      scrollThreshold: 100,
      expandedMenus: {
        about: false,
        business: false,
        manufacturing: false,
        media: false,
        sustainability: false,
        contact: false
      }
    };
  },
  computed: {
    isMediaDetailPage() {
      return this.$route.path === '/media-detail';
    },
    isMediaKeyPage() {
      return this.$route.path === '/media-key';
    }
  },
  created() {

  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      if (!this.isMenuOpen) {
        this.resetExpandedMenus();
      }
    },
    closeMenu() {
      this.isMenuOpen = false;
      this.resetExpandedMenus();
    },
    resetExpandedMenus() {
      Object.keys(this.expandedMenus).forEach(key => {
        this.expandedMenus[key] = false;
      });
    },
    handleNavClick(menuKey, defaultRoute, event) {
      const isDropdownItem = event.target.closest('.dropdown-item');
      if (isDropdownItem) return;
      
      if (window.innerWidth > 1024) {
        // PC端：跳转到第一个下拉菜单项
        if (this.$route.path !== defaultRoute) {
          this.$router.push(defaultRoute);
        }
      } else {
        // 移动端：展开/收起下拉菜单
        event.preventDefault();
        event.stopPropagation();
        
        Object.keys(this.expandedMenus).forEach(key => {
          if (key !== menuKey) {
            this.expandedMenus[key] = false;
          }
        });
        
        this.expandedMenus[menuKey] = !this.expandedMenus[menuKey];
      }
    },

    goToChineseWebsite() {
      window.open('https://www.jshlfd.com/', '_blank');
    },
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.isFixed = scrollTop > this.scrollThreshold;
    }
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style scoped>
#hbox {
  width: 100%;
  background: transparent;
  transition: all 0.3s ease;
  position: absolute;
  top: 0;
  z-index: 1000;
  font-family: 'MiSans-Demibold';
}

#hbox:hover {
  background: rgba(255, 255, 255, 0.3);
}

#hbox.is-fixed {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.7);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  animation: slideDown 0.3s ease;
}

#hbox.is-fixed .nav-item {
  color: #000;
}

#hbox.is-fixed .nav-item-wrapper:hover .nav-item {
  color: #003D90;
}

#hbox.is-fixed .hamburger span {
  background: #000;
}

@keyframes slideDown {
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.header-container {
  /* max-width: 1765px; */
  width: clamp(80%, 85%, 1800px);
  margin: 0 auto;
  /* padding: 0px 2vw 0 2vw; */
  height: 90px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  align-items: center;
  
}

.logo {
  flex-shrink: 0;
  margin-right: 1rem;
}

.logo img {
  width: clamp(180px, 18vw, 300px);
  height: auto;
  display: block;
}

.hamburger {
  display: none;
  flex-direction: column;
  justify-content: space-around;
  width: 30px;
  height: 25px;
  cursor: pointer;
  z-index: 1002;
  padding: 5px 0;
}

.hamburger span {
  width: 100%;
  height: 3px;
  background: #fff;
  border-radius: 3px;
  transition: all 0.3s ease;
}

.hamburger.active span:nth-child(1) {
  transform: rotate(45deg) translate(8px, 8px);
}

.hamburger.active span:nth-child(2) {
  opacity: 0;
}

.hamburger.active span:nth-child(3) {
  transform: rotate(-45deg) translate(7px, -7px);
}

.nav-menu {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  /* gap: clamp(30px, 2.5vw, 70px); */
  gap: clamp(18px, 1.5vw, 70px);
  height: 100%;
}

.nav-item-wrapper {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
}

.nav-item {
  font-size: 18px;
  color: #fff;
  font-weight: 500;
  transition: color 0.3s ease;
  position: relative;
  display: block;
  white-space: nowrap;
  cursor: pointer;
}

/* .nav-item::after {
  content: "";
  position: absolute;
  top: 30px;
  left: 0;
  width: 0;
  height: 2px;
  background: #fff;
  transition: width 0.3s ease, background 0.3s ease;
} */

.nav-item:hover::after,
.nav-item.router-link-active::after {
  width: 100%;
}
.nav-item-wrapper:hover .nav-item{
  color: #003D90;
}
.nav-item-wrapper:hover .nav-item::after {
  width: 100%;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(12, 60, 136, 0.85);
  padding: 15px 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1001;
  justify-content: flex-start;
  box-sizing: border-box;
  min-width: 200px;
}

.nav-item-wrapper:hover .dropdown-menu {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

.dropdown-item {
  font-size: 14px;
  color: #fff;
  text-decoration: none;
  padding: 8px 12px;
  transition: all 0.3s ease;
  text-align: center;
  border-radius: 4px;
  white-space: nowrap;
}

.dropdown-item:hover {
  color: #6AD374;
}

.search-icon {
  flex-shrink: 0;
  cursor: pointer;
  transition: transform 0.3s ease;
  display: flex;
  align-items: center;
  gap: 1.5vw;
}

.search-icon img {
  transition: filter 0.3s ease;
}

#hbox.is-fixed .search-icon img {
  filter: invert(1);
}

/* MediaDetail 和 MediaKeyView 页面搜索图标反色 */
#hbox.media-detail-page .search-icon img,
#hbox.media-key-page .search-icon img {
  filter: invert(1);
}

.phone-wrapper {
  display: flex;
  align-items: center;
  position: relative;
  padding: 20px 0;
}

.phone-number {
  font-size: 13px;
  color: #fff;
  white-space: nowrap;
  position: absolute;
  left: 50%;
  top: calc(100% + 8px);
  transform: translateX(-50%) translateY(-10px);
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  padding: 0 12px;
  pointer-events: auto;
  background: rgba(12, 60, 136, 0.9);
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.phone-number::before {
  content: '';
  position: absolute;
  top: -6px;
  left: 50%;
  transform: translateX(-50%);
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid rgba(12, 60, 136, 0.9);
}

#hbox.is-fixed .phone-number {
  color: #fff;
  background: rgba(0, 61, 144, 0.95);
}

#hbox.is-fixed .phone-number::before {
  border-bottom-color: rgba(0, 61, 144, 0.95);
}

.phone-wrapper:hover .phone-number,
.phone-number:hover {
  max-height: 50px;
  opacity: 1;
  padding-top: 8px;
  padding-bottom: 8px;
  transform: translateX(-50%) translateY(0);
}

.language-icon {
  width: 100%;
}

.mobile-language {
  display: none;
}

.mobile-arrow {
  display: none;
}
@media (min-width: 1920px) {
  /* .header-container {
    max-width: 1765px;
  } */

  .nav-item {
    font-size: 17px;
  }

  .nav-item::after {
    top: 32px;
  }

  .dropdown-menu {
    padding: 18px 25px;
    gap: 10px;
  }

  .dropdown-item {
    font-size: 15px;
    padding: 10px 15px;
  }
}

@media (max-width: 1440px) {

  .nav-item {
    font-size: 15px;
  }

  .dropdown-menu {
    padding: 12px 20px;
  }

  .dropdown-item {
    font-size: 13px;
    padding: 6px 10px;
  }
}

@media (max-width: 1200px) {
  /* .header-container {
    padding: 45px 3vw 0 3vw;
  } */

  .nav-item {
    font-size: 14px;
  }

  .nav-item::after {
    top: 26px;
  }

  .dropdown-menu {
    padding: 10px 15px;
    gap: 15px;
  }

  .dropdown-item {
    font-size: 13px;
    padding: 6px 8px;
  }
}

@media (max-width: 1024px) {
  .header-container {
    padding: 0 20px;
    height: 70px;
    align-items: center;
  }

  .hamburger {
    display: flex;
  }

  .nav-menu {
    position: fixed;
    top: 70px;
    left: 0;
    right: 0;
    bottom: 0;
    flex-direction: column;
    justify-content: flex-start;
    gap: 0;
    background: #fff;
    overflow-y: auto;
    overflow-x: hidden;
    z-index: 1001;
    padding: 0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateX(100%);
    transition: transform 0.3s ease;
    will-change: transform;
  }

  .nav-menu.mobile-open {
    transform: translateX(0);
  }

  .nav-item-wrapper {
    width: 100%;
    border-bottom: 1px solid #eee;
    cursor: pointer;
    position: relative;
    display: block;
    height: auto;
  }

  .nav-item {
    padding: 16px 20px;
    color: #333;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    z-index: 1;
    background: #fff;
  }

  .nav-item::after {
    display: none;
  }

  .mobile-arrow {
    display: block;
    font-size: 12px;
    color: #999;
    transition: transform 0.3s ease;
    flex-shrink: 0;
    margin-left: 10px;
  }

  .nav-item-wrapper.mobile-expanded .mobile-arrow {
    transform: rotate(180deg);
  }

  .dropdown-menu {
    position: relative;
    width: 100%;
    background: #f5f7fa;
    padding: 0;
    display: block;
    flex-direction: column;
    gap: 0;
    opacity: 1;
    visibility: visible;
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);
    margin: 0;
    border: none;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
    will-change: max-height;
    top: auto;
    left: auto;
    transform: none;
  }

  .nav-item-wrapper.mobile-expanded .dropdown-menu {
    max-height: 500px;
    overflow-y: auto;
  }

  .dropdown-item {
    padding: 14px 20px 14px 40px;
    text-align: left;
    font-size: 14px;
    border-radius: 0;
    white-space: normal;
    color: #555;
    border-bottom: 1px solid #e8eaed;
    line-height: 1.5;
    display: block;
    width: 100%;
    box-sizing: border-box;
    position: relative;
  }

  .dropdown-item::before {
    content: '';
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
    width: 6px;
    height: 6px;
    background: #ccc;
    border-radius: 50%;
  }

  .dropdown-item:last-child {
    border-bottom: none;
  }

  .dropdown-item:hover,
  .dropdown-item:active {
    background: #e8f4fd;
    color: #0066cc;
  }

  .dropdown-item:hover::before,
  .dropdown-item:active::before {
    background: #0066cc;
  }

  .mobile-language {
    display: flex;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid #eee;
    cursor: pointer;
    color: #333;
    font-size: 16px;
    background: #fff;
  }

  .mobile-language img {
    width: 24px;
    height: 24px;
    margin-right: 12px;
  }

  .mobile-language span {
    font-size: 16px;
  }

  .search-icon {
    display: none;
  }

  #hbox:hover {
    background: rgba(255, 255, 255, 0.95);
  }

  .hamburger span {
    background: #333;
  }
}

@media (max-width: 480px) {
  .header-container {
    padding: 0 15px;
    height: 60px;
  }

  .nav-menu {
    top: 60px;
  }

  .nav-item {
    padding: 14px 15px;
    font-size: 15px;
  }

  .dropdown-item {
    padding: 12px 15px 12px 35px;
    font-size: 13px;
  }

  .dropdown-item::before {
    left: 15px;
    width: 5px;
    height: 5px;
  }

  .mobile-language {
    padding: 14px 15px;
    font-size: 15px;
  }
}
</style>